/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { observer } from 'mobx-react-lite';
import { DateColumn } from '@veeam-vspc/components';

import type { DateColumnProps } from '@veeam-vspc/components';

import { useAppStore } from 'views/providers/AppProvider/hooks';

export interface GridDateColumnProps extends Partial<DateColumnProps> {
    value: DateColumnProps['value'];
}

export const GridDateColumn = observer(({ value, ...restProps }: GridDateColumnProps) => {
    const { formats } = useAppStore();
    const { netShortDate, netShortTime } = formats;

    return (
        <DateColumn
            {...restProps}
            value={value}
            shortDateFormat={netShortDate}
            shortTimeFormat={netShortTime}
        />
    );
});
